import { render, staticRenderFns } from "./IssueCategoriesList.vue?vue&type=template&id=1e58a09b&"
import script from "./IssueCategoriesList.vue?vue&type=script&lang=js&"
export * from "./IssueCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports